import { render, staticRenderFns } from "./lose_reason_table.vue?vue&type=template&id=1b12d136"
import script from "./lose_reason_table.vue?vue&type=script&lang=ts"
export * from "./lose_reason_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports